import { render, staticRenderFns } from "./VueScheduler.vue?vue&type=template&id=87f98420&scoped=true&"
import script from "./VueScheduler.vue?vue&type=script&lang=js&"
export * from "./VueScheduler.vue?vue&type=script&lang=js&"
import style0 from "./VueScheduler.vue?vue&type=style&index=0&id=87f98420&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f98420",
  null
  
)

component.options.__file = "VueScheduler.vue"
export default component.exports